import React from 'react';

import classnames from 'classnames';

import 'css/components/_Stack.scss';

type Direction = 'horizontal' | 'vertical';
type Alignment = 'start' | 'center' | 'end' | 'stretch' | 'baseline';
type Justify =
  | 'start'
  | 'center'
  | 'end'
  | 'space-between'
  | 'space-around'
  | 'space-evenly'
  | 'stretch';
type Spacing = 'none' | 'xs' | 'sm' | 'md' | 'lg' | 'xl';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
  direction?: Direction;
  alignment?: Alignment;
  justify?: Justify;
  spacing?: Spacing;
  wrap?: boolean;
  fullWidth?: boolean;
  fullHeight?: boolean;
}

const Stack = ({
  children,
  className,
  direction = 'vertical',
  alignment = 'start',
  justify = 'start',
  spacing = 'none',
  wrap = false,
  fullWidth = false,
  fullHeight = false,
  ...props
}: Props) => {
  return (
    <div
      {...props}
      className={classnames('stack', className, {
        [`direction-${direction}`]: true,
        [`alignment-${alignment}`]: true,
        [`justify-${justify}`]: true,
        [`spacing-${spacing}`]: true,
        wrap,
        'full-width': fullWidth,
        'full-height': fullHeight,
      })}>
      {children}
    </div>
  );
};

export default Stack;
